import axios from 'axios'
import store from '@/store'

export default {

  async getWastelessProducts () {
    try {
      if (new Date().getTime() - (3600000) > store.state.lastWastelessUpdate) {
        let result = await axios.get(store.getters.getProductV2Api + '/wasteless/products?company_id=' + store.getters.getChoiceCompanyId)
        if (result.data) {
          store.state.wastelessProducts = result.data
          return store.state.wastelessProducts
        } else {
          return null
        }
      } else {
        return store.state.wastelessProducts
      }
    } catch (e) {
      console.log(e)
      return null
    }
  },

  async getProductsIndex () {
    if ((!store.state.productsIndex.length || new Date().getTime() - (3600000) > store.state.productsIndexLastUpdate ) && !store.state.productsIndexLoading) {
      store.state.productsIndexLoading = true
      store.state.productsIndexLastUpdate = new Date().getTime()
      let pIndex = await axios.get(store.getters.getProductsIndexApi + '/' + store.getters.getChoiceCompanyId + '/name_index/index.json?t=' + new Date().getTime())
      store.state.productsIndex = pIndex.data
      store.state.productsIndexLoading = false
    }
  },

  async getProductsByIds (ids) {

    //clear products if more than 1 hour
    if (store.state.lastProductsUpdate < new Date().getTime() - 3600000){
      store.state.products = []
      console.log('clear cache')
    }

    let filteredIds = []
    let responseProducts = []
    if (store.getters.getProducts.length) {
      ids.forEach((id) => {
        let product = this.getProductByIdOnCache(id)
        if (product) {
          responseProducts.push(product)
        } else {
          filteredIds.push(id)
        }
      })
    } else {
      filteredIds = ids
    }
    console.log('filtered ids', filteredIds )
    if (filteredIds && filteredIds.length) {
      // do not search more than 80 by request, for performance reasons
      if (filteredIds.length > 80) {
        filteredIds = filteredIds.splice(0,80)
      }
      let products = await axios.get(store.getters.getProductV2Api + '/products/batch?ids=' + JSON.stringify(filteredIds))
      if (products.data) {
        console.log('response products', products.data)
        // add a fake stock to companies that not consider stock and may send a negative value
        if (!store.getters.getChoicedCompany.stock_configuration) {
          products.data.forEach((p) => {p.product_views[0].stock_quantity = 1000})
        }
        store.state.products = store.state.products.concat(products.data)
        store.state.products.sort((a, b) => a.order - b.order)
        responseProducts = responseProducts.concat(products.data)
        store.state.lastProductsUpdate = new Date().getTime()
        responseProducts.sort((a, b) => a.order - b.order)
      } else {
        console.log('error to get products part')
      }
      console.log('get products from db')
    } else {
      console.log('search full from cache')
    }
    console.log('response products', responseProducts)
    return responseProducts
  },

  getAll () {
    // TODO SINGLE CALL
    console.log('call get all')
    let response = {}
    response.data = store.getters.getProducts
    return response
  },

  async getAllProductsByCategoryId (categoryId, pageSize, offset, offsetOrder) {
    try {
      if (!pageSize) {
        pageSize = 10
      }
      let result = await axios.get(store.getters.getProductV2Api + '/products' +
        '?company_id=' + store.getters.getChoiceCompanyId +
        (categoryId && categoryId !== '0' ? '&category_id=' + categoryId : '') + 
        '&page_size=' + pageSize +
        (offset !== undefined && offset !== null ? '&offset=' + offset : '') +
        (offsetOrder !== undefined &&  offsetOrder !== null ? '&offset_order=' + offsetOrder : '')
        )
      if (result.data) {
        // add a fake stock to companies that not consider stock and may send a negative value
        if (!store.getters.getChoicedCompany.stock_configuration) {
          result.data.forEach((p) => {p.product_views[0].stock_quantity = 1000})
        }
        store.state.products = store.state.products.concat(result.data)
        return result.data
      } else {
        console.log('no data fetched from products category')
        return []
      }
    } catch (e) {
      console.log(e)
      return []
    }
  },

  async getProductById (id) {
    let products = await this.getProductsByIds([id])
    if (products.length) {
      return products[0]
    } else {
      return null
    }
  },

  getProductByIdOnCache (id) {
    let allProducts = store.getters.getProducts
    let productFiltered = allProducts.filter(p => p.id === id)
    if (productFiltered.length) {
      return productFiltered[0]
    } else {
      return null
    }
  },
  
  async getAllProductList () {
    if (!store.getters.getProductList.length) {
      let response = await axios.get(store.getters.getProductV2Api + '/product-list?company_id=' + store.getters.getChoiceCompanyId)
      if (response.data) {
        let productsList = response.data
        productsList.forEach(async (productList) => {
          let productsDB = await this.getProductsByIds(productList.products.map(p => p.id))
          // console.log(productsDB)
          productList.products.forEach(product => {
            // the product need to be active to be listed as promoted
            let productFiltered = productsDB.filter(p => p.id === product.id && p.active === true)
            product.product = (productFiltered.length ? productFiltered[0] : null)
          })
          productList.products.sort((a, b) => {
            return a.order - b.order
          })
        })
        response.data = productsList
        // guarda a lista tratada na sessao para proximas chamadas
        store.state.productList = productsList
        store.state.productList.sort((a, b) => a.order - b.order)
      }
      return response
    } else {
      let response = {data:[]}
      response.data = await store.getters.getProductList
      return response
    }
  },

  async getProductListById (id) {
    let productsListProducts = []
    let response = await axios.get(store.getters.getProductV2Api + '/product-list/' + id)
    if (response.data) {
      let productList = response.data
      let productsDB = await this.getProductsByIds(productList.products.map(p => p.id))
      // console.log(productsDB)
      productList.products.forEach(product => {
        // the product need to be active to be listed as promoted
        let productFiltered = productsDB.filter(p => p.id === product.id && p.active === true)
        product.product = (productFiltered.length ? productFiltered[0] : null)
      })
      productList.products.sort((a, b) => {
        return a.order - b.order
      })
      productsListProducts = productList.products
    }
    return productsListProducts
    
  }



}